module.exports = __webpack_public_path__ + "static/f_capabilities_3_5-d341f906311cc47ab6ebfdf9e985076e.png";